<template>
  <div class="animated fadeIn">
   
    <b-row >
       
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong>Status Report</strong> 
             </div>



          <b-row style="margin-top:-5%">
          
         <b-col md="12" class="my-1">
           
            <b-row class="form-group">

                   <b-col sm="3">
                        <div id='container' style="margin:50px auto 0; width:250px;">
        <br>     
<ejs-multiselect id='multi_select1' placeholder="Select Rider" v-model="value2" :dataSource='options'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='fields' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
></ejs-multiselect>
          </div>

 

               </b-col>

                   <div id='container' style="margin:50px auto 0; width:250px;">
        <br>     
<ejs-multiselect id='multi_select2' placeholder="Select vendor" v-model="value3" :dataSource='vendoroptions'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"     :fields='fields' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
></ejs-multiselect>
          </div>

                       <!--  <b-col sm="3">
              <b-form-group label="Select Vender"  :label-cols="4" >
                 <b-form-select class="form-control input" v-model="vendorid" name="vendorid" >
                        <option :value="selected"  >--Select--</option>
                        <option v-for="vendor in vendorlist"  v-bind:value="vendor.vendor_name">{{vendor.vendor_name}} </option>
                   </b-form-select>
                 </b-form-group>
               </b-col> -->
             
              <b-col sm="3">
  
                    <div id='container' style="margin:50px auto 0; width:250px;">
        <br>   
        <!-- {{value4}}   -->
<ejs-multiselect id='multi_select3' placeholder="Select Shipment status" v-model="value4"  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All" :dataSource='statusoptions'   :fields='fields' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" v-on:change="hidedropdown(value4)"
></ejs-multiselect>
          </div>
                               
              </b-col>
                 <b-col sm="3">
                  <div id='container' style="margin:50px auto 0; width:250px;">
        <br>     
<ejs-multiselect id='multi_select4' placeholder="Select Zone " v-model="value8" :dataSource='zoneoptions'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"     :fields='fields' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
></ejs-multiselect>
          </div>
                      <!-- <div id='container' style="margin:50px auto 0; width:250px;">
        <br>     
<ejs-multiselect id='multiselect' placeholder="Select Location " v-model="value5" :dataSource='locationoptions'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"     :fields='fields' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
></ejs-multiselect>
          </div> -->

          <!--     <b-form-group label="Shipment status"  :label-cols="4" >
                 <b-form-select class="form-control input" v-model="shipmentstatus" name="shipmentstatus" >
                        <option :value="selected"  >--Select--</option>
                        <option v-for="shipment in shipmentstatuslist"  v-bind:value="shipment.process">{{shipment.process}}</option>
                   </b-form-select>
                 </b-form-group> -->
               </b-col> 

                <b-col sm="3">
                        <div id='orderflowmultiselect' style="margin:50px auto 0; width:250px;">
        <br>     
  <div>
    
  </div>
  

     <!-- <div v-if="value4[4]!='HandoverPending'">  -->
   
<ejs-multiselect id='orderflowmultiselect' placeholder="Select Order Flow" v-model="value6" :dataSource='orderflowoptions'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All" :fields='flowfields' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
></ejs-multiselect>
   <!-- </div> -->

          </div>

 

               </b-col>


<!--                 <b-col sm="3">
                        <div id='container' style="margin:50px auto 0; width:250px;">
        <br>     
<ejs-multiselect id='multiselect' placeholder="Select Shipment Type" v-model="value7" :dataSource='shipmentoptions'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='statusfields' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
></ejs-multiselect>
          </div>

 

               </b-col>
 -->
            
              
          <b-col sm="3" style="margin-top:6%">
                <b-form-group label="From Date:"  :label-cols="3" >
                 <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                </v-date-picker>
                </b-form-group>
              </b-col>
              <b-col sm="3" style="margin-top:6%">
                <b-form-group label="To Date:"  :label-cols="3" >
                  <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                  </v-date-picker>
                </b-form-group>
              </b-col>

                  <b-col sm="3" style="margin-top:6%">
                    <b-button  size="md" variant="primary"@click="setSelecteddate(); Dashboardcall();"> Search</b-button>      </b-col>   
             

               


            </b-row>               
                         
          </b-col>   
              

              
            </b-row> 
             <b-row>
          
         <b-col md="12" class="my-1">
           
            <b-row class="form-group">

             <!--  <b-col sm="3">
                    

                <b-form-group label="Order Flow:"  :label-cols="4" >
                  <b-form-select v-model="orderflow" name="orderflow" class="mySelectBox" v-validate="'required'" >
                    <option :value="selected">--Selected order flow--</option>
                    <option value="">All</option>
                    <option value="forward">Forward</option>
                    <option value="reverse">Reverse</option>
                  </b-form-select>                                
                </b-form-group>                   
              </b-col>
 -->
        <!--       <b-col sm="3">



            <b-form-group label="Shipment Type:"  :label-cols="4" >
                  <b-form-select v-model="shipmenttype" name="shipmenttype" class="mySelectBox" v-validate="'required'" >
                    <option :value="selected">--Selected order flow--</option>
                    <option value="">FM</option>
                    <option value="forward">LM</option>
                    <option value="reverse">RVP</option>
                  </b-form-select>                                
                </b-form-group> 

              <b-form-group label="Location Id"  :label-cols="4" >
                 <b-form-select class="form-control input" v-model="locationid" name="locationid" >
                        <option :value="selected"  >--Select--</option>
                        <option v-for="location in locationlist"  v-bind:value="location.locality_id">
                        {{ location.locality_name}} </option>
                   </b-form-select>
                 </b-form-group>
               </b-col> -->

             
              
              

                

                  
                           
             

             

<!-- 
                 <b-col cols="3">
                <b-button size="md" variant="primary" @click="showCSV"> Search</b-button>&nbsp;&nbsp;&nbsp;
                
              </b-col>
                    <b-col sm="3">
               <b-col sm="12" class="text-right">
               <b-button size="md" variant="primary" type="button" @click="downloadCSV">Dowanload</b-button>
              </b-col>  
              </b-col> -->

            </b-row>               
                         
          </b-col>   
              

              
            </b-row> 



            
           












          <b-row>
           <b-col md="12" >
    
           <div>
            <ul class="nav nav-tabs nav-justified">
             
             

              <li class="nav-item">
                <a @click="activeTab = 1"  class="nav-link" :class="{'active' : isActiveTab(1)}" >Dashboard</a>
              </li>

              <li class="nav-item">
                <a @click="activeTab = 2"  class="nav-link " :class="{'active' : isActiveTab(2)}">Listing</a>
              </li>
             
             
            </ul>
          </div>
           
          </b-col>
          <b-col md="12"  class="text-right">
       

            <div class="tab-panel" v-if="isActiveTab(1)">
            <status_dashboard_adv style="width:70%;"></status_dashboard_adv>
            </div>

            <div class="tab-panel" v-if="isActiveTab(2)">
              <status_listing_adv style="width:70%;"></status_listing_adv>
            </div>

           

     
        
             </b-col>

          </b-row> 
        </b-card>
       
      </b-col>
    </b-row> 
  </div>   


</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";

import status_dashboard_adv from './status_dashboard_adv.vue'
import status_listing_adv from './status_listing_adv.vue'
import { EventBus } from "./event-bus.js";


export default {
  data: function() {
    return {
      activeTab: 1,
      status_dashboard_adv,
      status_listing_adv,
      id:'',
      customer: {},
      customer1:{},
      selectDateFrom: new Date(),
      selectDateTo:new Date(),
      Count: 0  ,
      data1:[],
      data2:[],
      agentmaster: [],
      locationlist:[],
      zonenamelist:[],
      shipmentstatuslist:[],
      shipmentflow:'',
      vendorlist:[],
      deliveryagentid:'',
      orderflow:'',
      locationid:'',
      vendorid:'',
     shipmenttype:'',
     selected:'',
     shipmentstatus:'',
      options: [],
      vendoroptions:[],
      statusoptions:[],
      locationoptions:[],
       zoneoptions:[],

      orderflowoptions:[
        
        { Id: 'forward', flow: 'Forward' },
        { Id: 'reverse', flow: 'Reverse' },
        
      ],
       shipmentoptions:[
        { Id: '3PL', status1: 'Fm' },
        { Id: 'vendor,warehouse', status1: 'Lm' },
        { Id: 'reverse', status1: 'RVp' },
        
      ],
      flowfields : { text: 'flow', value: 'Id' },
      statusfields:{text: 'status1', value: 'Id'},
      
      value2:[],
      value3:[],
      value4:[],
      value5:[],
      value6:[],
      value7:[],
      value8:[],

      allowCustomValue : true,

    fields: { text: 'name', value: 'id' },

        
      
      name: 'status_dashboard_adv',
      showSelectAll : true
     
    };
  },
  components: {
   

    status_dashboard_adv,
    status_listing_adv
   
  },
 
  created: function() {
   
    this.setSelecteddate();
     this.isActiveTab(1);
      

     this.displaydeliveryagent();
    // this.location();
    this.zone();

     this.vendor();
     this.shipment();
   
   
   
   

  },
 
  methods: {
 

     displaydeliveryagent: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
        hub_id:`${userInfo.pickuplocationmasterid}`,
        
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
          this.agentmaster = result.body;

           for(var i = 0; i < this.agentmaster.length; i++) {
            var deliveryagent2 = {
        name: this.agentmaster[i].deliveryagentmasterid+" - "+this.agentmaster[i].deliveryagentfirstname+" - "+this.agentmaster[i].deliveryagentlastname,
        id: this.agentmaster[i].deliveryagentmasterid
      }
 this.options.push(deliveryagent2);
        // this.options.push(this.agentmaster[i].deliveryagentfirstname);
           
       }
       // console.log('--------gfg----------');
       // console.log(this.options);
       //        console.log('------------------');

        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },
     hidedropdown:function(value) {
      // alert(value)
      //alert("i m in on chnage");
    //console.log(value.includes("Reallocate"));   if(value.includes("Reallocate"))
    if(value.includes("HandoverPending")||value.includes("RTO")||value.includes("RTOHandoverDoneToLocation"))
    {
      // alert(": i m in if");
      document.getElementById("orderflowmultiselect").style.display="none";
    }
    else
    {
      document.getElementById("orderflowmultiselect").style.display="block";
    }
},
//     downloadCSV: function() {
      


//      var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
//       var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
//       var vendorid = JSON.parse(localStorage.getItem("vendorarr"));
      
//       var deliveryagentid = JSON.parse(localStorage.getItem("deliveryagentidarr"));
     
     
      
//           var csvObj = {
//             fromdate: `${fromdate}`,
//             todate:`${formatdateto}`,
//             vendor:vendorid,
//             deliveryagentid:deliveryagentid
            
           
//           };
         
      

//       console.log(csvObj);
     
      
//         var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// console.log(queryString);
//       if(formatdateto< fromdate){
//         alert('To date need to be grater than From date');
          
//       }
//       //var r = Math.random().toString(36).substring(3);
//   this.$http.get(`${CONSTANTS.MISREPORT_API_URL}/statusreportdashboardcsv`+queryString)
//         .then(result => {
//          console.log(result.url);
//         window.location.href =result.url;
//         });
        
//     },

    

//     location: function() {
//       var userdata = localStorage.getItem('userData')
//       var userInfo = JSON.parse(userdata)
//       //agentmaster
//       const deliveryagent = {
//         deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
//         isactive: '1'
//       }
// this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getlocationlist`)
//         .then((result) => {
//           this.locationlist = result.body
//           for(var i = 0; i < this.locationlist.length; i++) {
//             var location2 = {
//         name: this.locationlist[i].locality_name,
//         id: this.locationlist[i].locality_id,
//       }
//  this.locationoptions.push(location2);
//         // this.options.push(this.agentmaster[i].deliveryagentfirstname);
           
//        }

//         })
//         .catch((ex) => {
//           console.log('error', ex)
//         })
//     },


     zone: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1'
      }
this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getzonename`)
        .then((result) => {
          this.zonenamelist = result.body
          // console.log("mmmmm"+this.zonenamelist.length);
          
          for(var i = 0; i < this.zonenamelist.length; i++) {
            var zone2 = {
        name: this.zonenamelist[i].zone_name,
        id: this.zonenamelist[i].zone_name,
      }
      // console.log("mmmmm"+this.zonenamelist.length);
 this.zoneoptions.push(zone2);
        // this.options.push(this.agentmaster[i].deliveryagentfirstname);
           
       }

        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },


    vendor: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1'
      }
this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getvendorlist`)
        .then((result) => {
          this.vendorlist  = result.body
                 for(var i = 0; i < this.vendorlist.length; i++) {
            var vendor2 = {
        name: this.vendorlist[i].vendor_name,
         id: this.vendorlist[i].vendor_name,
       
      }
 this.vendoroptions.push(vendor2);
        // this.options.push(this.agentmaster[i].deliveryagentfirstname);
           
       }

        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },
    shipment: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1'
      }
this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getshipmentstatus`)
        .then((result) => {
          this.shipmentstatuslist  = result.body;
          // console.log("shipmentstatuslist", this.shipmentstatuslist);
          // this.shipmentflow=result.body[4].process;
          // console.log("shipmentflow", this.shipmentflow);
           for(var i = 0; i < this.shipmentstatuslist.length; i++) {

            var shipmentstatus2 = {
        name: this.shipmentstatuslist[i].process,
        id: this.shipmentstatuslist[i].process,
      }
      // var flow=this.shipmentstatus2;
      // console.log("Hiii",shipmentstatus2);
 this.statusoptions.push(shipmentstatus2);
 // console.log("statusoptions",this.statusoptions);
        // this.options.push(this.agentmaster[i].deliveryagentfirstname);
           
       }

        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },

    // hideflow:function(value){
    //   alert(value);
    //    for(var i = 0; i < value.length; i++) {
    //     console.log("Hiii",value[i].length);
    //     console.log("hello",value[i]);
    //     if(value[i]=='HandoverPending'){
    //       // alert("innn");
    //       // console.log("kkkkk",value[i].length);
    //       document.getElementById("orderflowmulti").style.display = "none";
    //     }
    //     else{
    //       document.getElementById("orderflowmulti").style.display = "block";
    //     }
    //   }
            
    // },
   Dashboardcall() {  
    // alert("count example");
   // this.Count++;  
      // Send the event on a channel (i-got-clicked) with a payload (the click count.)  
      EventBus.$emit("clicked-event", this.Count);  
      }  ,


setSelecteddate: function() { 
 // console.log('------hi--------');
 
 
 // console.log(this.value2);

 //  console.log('------hi--------');


         var deliveryagentidarr=[];
          deliveryagentidarr=this.value2;
          
          // var locationarr=[];
          // locationarr.push(JSON.stringify(this.locationid));
        
        var vendorarr=[];
          vendorarr=this.value3;

           var statusarr=[];
          statusarr=this.value4;
          // console.log("Hello",statusarr);

           var locationarr=[];
          locationarr=this.value5;

           var zonearr=[];
          zonearr=this.value8;


           var orderflowarr=[];
          orderflowarr=this.value6;

           var statustypearr=[];
          statustypearr=this.value7;
           
        
        
        // var vendorarr=[];
        //  locationarr.push(JSON.stringify(this.vendorid));

      // for(var i = 0; i < this.deliveryagentid.length; i++) {
          //deliveryagentidarr.push(this.deliveryagentid);  
       //}
// console.log("ARR:",deliveryagentidarr);

   var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
    
    var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
    
    var orderflow=(this.orderflow!=null)? this.orderflow:"";
    
    
    var vendorid=(this.vendorid!=null)? this.vendorid:"";
     
     var shipmenttype=(this.shipmenttype!=null)? this.shipmenttype:"";
      
      var shipmentstatus=(this.shipmentstatus!=null)? this.shipmentstatus:"";


  
      localStorage.setItem("fromdate", fromdate);
      localStorage.setItem("todate", formatdateto);
      localStorage.setItem("deliveryagentidarr", JSON.stringify(deliveryagentidarr));
       localStorage.setItem("locationarr", JSON.stringify(locationarr));
       localStorage.setItem("zonearr", JSON.stringify(zonearr));
      //localStorage.setItem("deliveryagentid", deliveryagentid);
      //localStorage.setItem("orderflow", orderflow);
      
       localStorage.setItem("vendorarr", JSON.stringify(vendorarr));
        localStorage.setItem("statusarr", JSON.stringify(statusarr));
      //localStorage.setItem("vendorid", vendorid);
      localStorage.setItem("orderflowarr", JSON.stringify(orderflowarr));
       // localStorage.setItem("stattusarr", JSON.stringify(stattusarr));


      localStorage.setItem("statustypearr",statustypearr);
      // localStorage.setItem("shipmentstatus", shipmentstatus);
    
      },


        formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },


 
  	isActiveTab(id)

    {
      
       return this.activeTab === id
    },



    

  },




  

};

</script>





